// extracted by mini-css-extract-plugin
module.exports = {"empty":"cards_empty__lHhzQ","virtualized-list":"cards_virtualized-list__CSu10"};